import {
  FETCH_SIMILAR_PRODUCTS,
  FETCH_TRACKING_SALE,
  LOADING_ORDER,
} from "../actions/types";

export interface OrderTracking {
  sale: {
    id: string;
    number: string;
    status_details: Array<any>;
    traking_code?: string;
    client_id: number;
    created_at: string;
    date: string;
    client: {
      name: string;
      last_name: string;
      address: string;
      city: string;
      postal_code: string;
      provinces?: { name: string };
    };
    subtotal?: number;
    total: number;
    increase1?: number;
  };
  saleDetails: Array<any>;
}

export interface OrderSimilarProducts {
  productName: string;
  similarProducts: any[];
  loading?: boolean;
}

export interface SwapChange {
  saleDetailId: string;
  productId: string;
  quantity: number;
  newProductName: string;
  newProductSize: string;
  originalProductName: string;
  originalProductSize: string;
  originalQuantity: number;
}

export interface OrderState {
  trackingOrder: OrderTracking | null;
  similarProducts: OrderSimilarProducts | null;
  isLoading: boolean;
  isSavingSwaps?: boolean;
  swaps: SwapChange[];
}

const initialState: OrderState = {
  trackingOrder: null,
  similarProducts: null,
  isLoading: false,
  isSavingSwaps: false,
  swaps: [],
};

function orderReducer(state = initialState, action: any): OrderState {
  switch (action.type) {
    case "SWAP_PRODUCTS_ORDER_REQUEST":
      return {
        ...state,
        isSavingSwaps: true,
      };
    case "SWAP_PRODUCTS_ORDER_SUCCESS":
    case "SWAP_PRODUCTS_ORDER_FAILURE":
      return {
        ...state,
        isSavingSwaps: false,
      };
    case LOADING_ORDER:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_TRACKING_SALE:
      return {
        ...state,
        trackingOrder: action.payload,
        isLoading: false,
      };
    case FETCH_SIMILAR_PRODUCTS:
      return {
        ...state,
        similarProducts: action.payload,
        isLoading: false,
      };
    case "CLEAR_SIMILAR_PRODUCTS":
      return {
        ...state,
        similarProducts: null,
        isLoading: false,
      };
    case "ADD_SWAP": {
      // If quantity is zero, remove the swap; otherwise, add or replace it
      const filteredSwaps = state.swaps.filter(
        (swap) => swap.saleDetailId !== action.payload.saleDetailId
      );
      if (action.payload.quantity === 0) {
        return {
          ...state,
          swaps: filteredSwaps,
        };
      }
      return {
        ...state,
        swaps: [...filteredSwaps, action.payload],
      };
    }
    case "CLEAR_SWAPS":
      return {
        ...state,
        swaps: [],
      };
    default:
      return state;
  }
}

export default orderReducer;
